var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1367 4.09375C16.1367 4.26953 16.1367 4.41016 16.1367 4.58594C16.1367 9.47266 12.4453 15.0625 5.66016 15.0625C3.55078 15.0625 1.61719 14.4648 0 13.4102C0.28125 13.4453 0.5625 13.4805 0.878906 13.4805C2.60156 13.4805 4.18359 12.8828 5.44922 11.8984C3.83203 11.8633 2.46094 10.8086 2.00391 9.33203C2.25 9.36719 2.46094 9.40234 2.70703 9.40234C3.02344 9.40234 3.375 9.33203 3.65625 9.26172C1.96875 8.91016 0.703125 7.43359 0.703125 5.64062V5.60547C1.19531 5.88672 1.79297 6.02734 2.39062 6.0625C1.37109 5.39453 0.738281 4.26953 0.738281 3.00391C0.738281 2.30078 0.914062 1.66797 1.23047 1.14062C3.05859 3.35547 5.80078 4.83203 8.85938 5.00781C8.78906 4.72656 8.75391 4.44531 8.75391 4.16406C8.75391 2.125 10.4062 0.472656 12.4453 0.472656C13.5 0.472656 14.4492 0.894531 15.1523 1.63281C15.9609 1.45703 16.7695 1.14062 17.4727 0.71875C17.1914 1.59766 16.6289 2.30078 15.8555 2.75781C16.5938 2.6875 17.332 2.47656 17.9648 2.19531C17.4727 2.93359 16.8398 3.56641 16.1367 4.09375Z",
    fill: "#00A4F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f1272db1cb075d3b9fb4f91d61812c34.svg";
export { ForwardRef as ReactComponent };